<template>
  <section class="w-full flex flex-row flex-nowrap justify-start items-center pb-2">
    <slot name="default" />
  </section>
</template>

<style scoped></style>
